import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

export const exportQuejasToExcel = (data, inmuebles, fileName = "quejas_reportes.xlsx") => {
    if (!data || data.length === 0) {
        alert("No hay datos para exportar");
        return;
    }

    const getInmuebleName = (id) => {
        const inmueble = inmuebles?.find(im => im.id === id);
        return inmueble ? inmueble.name : "Desconocido";
    };

    const exportData = data.map(q => ({
        Inmueble: getInmuebleName(q.propertieId),
        "Queja/Reporte": q.description,
        "Fecha de reporte": q.incident_date
            ? moment(q.incident_date).format("YYYY-MM-DD")
            : "",
        "Fecha de resolución": q.service_date
            ? moment(q.service_date).format("YYYY-MM-DD")
            : "Pendiente",
        "Comentario del usuario": q.comment_user || "",
        "Comentarios del servicio": q.comment_admin || "",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);

    ws['!cols'] = [
        { wch: 25 },
        { wch: 40 },
        { wch: 20 },
        { wch: 20 },
        { wch: 40 },
        { wch: 40 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Quejas_Reportes");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, fileName);
};
